import { TabsType } from 'components/Tabs/Tabs';
import { Translation } from 'hooks/useTranslation/useTranslation';

const is2FAEnabled = process.env.REACT_APP_IS_2FA_ENABLED === 'true';

export const createMyProfileTabs = (translation: Translation, isEntraLess: boolean): TabsType[] => [
  {
    text: translation.my_device,
    location: '/my-profile/my-device'
  },
  ...(isEntraLess && is2FAEnabled
    ? [
        {
          text: translation.security,
          location: '/my-profile/security'
        }
      ]
    : [])
];
